export default "__VITE_PUBLIC_ASSET__95f0233d__"